import { Select } from "antd";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { filterOptionDiacritics } from "../single-multiselect/SingleMultiselect";

interface FieldSelectProps {
  onDropdownVisibleChange?: (open: boolean) => void;
  onSelect?: (value: any, option: any) => void;
  notFoundContent?: React.ReactNode;
  onSearch?: (value: string) => void;
  dataList: Data[];
  allowClear?: boolean;
  filterOption?: any;
  value?: any;
  onChange?: (value: any, option: any) => void;
  onClear?: () => void;
  mode?: "multiple" | "tags";
  showSearch?: boolean;
  showSelectAll?: boolean;
  optionFilterProp?: string;
  placeholder?: string;
  maxSelectedCount?: number;
  className?: string;
}

interface Data {
  label: string;
  value: any;
  disabled?: boolean;
}

const MODE_MULTIPLE = "multiple";

const FieldSelect: React.FC<FieldSelectProps> = (props) => {
  const { t } = useTranslation("radar");

  const {
    mode,
    onDropdownVisibleChange,
    onSelect,
    notFoundContent,
    onSearch,
    dataList,
    allowClear,
    filterOption,
    value,
    onChange,
    showSearch,
    optionFilterProp,
    showSelectAll = true,
    onClear,
    maxSelectedCount,
    placeholder,
    className,
  } = props;

  const handleSelectAll = (value: any, option: any) => {
    if (value === "all" || value.includes("all")) {
      const allValues = dataList.map((option) => option.value);
      if (onChange) onChange(allValues, option);
    } else {
      if (onChange) onChange(value, option);
    }
  };

  const options = useMemo(() => {
    const handlerMaxSelectedCount = (): boolean => {
      return (
        maxSelectedCount &&
        mode === MODE_MULTIPLE &&
        value &&
        value.length >= maxSelectedCount
      );
    };

    const selectAllOption =
      dataList?.length > 0 && showSelectAll
        ? [{ label: t("pages.LabelsRanking.selectAll"), value: "all" }]
        : [];

    const dataOptions =
      dataList?.map((option: Data) => ({
        label: option.label,
        children: option.label,
        value: option.value,
        disabled:
          (handlerMaxSelectedCount() &&
            value &&
            !value?.includes(option.value)) ||
          option.disabled,
      })) || [];

    return [...selectAllOption, ...dataOptions];
  }, [dataList, showSelectAll, t, value, maxSelectedCount, mode]);

  return (
    <Select
      value={value}
      mode={mode}
      filterOption={filterOption ?? filterOptionDiacritics}
      onSearch={onSearch}
      onDropdownVisibleChange={onDropdownVisibleChange}
      onSelect={onSelect}
      notFoundContent={notFoundContent}
      allowClear={allowClear}
      maxTagCount="responsive"
      onChange={handleSelectAll}
      showSearch={showSearch}
      optionFilterProp={optionFilterProp}
      onClear={onClear}
      placeholder={placeholder}
      className={className}
      options={options}
    />
  );
};

export default FieldSelect;
